.sharing-status-label {
  text-transform: uppercase;
}
